"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var HeadingModuleForm_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadingModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const backoffice_1 = require("../../dsl/backoffice");
const form_1 = require("../_abstract/form");
const form_2 = require("../_components/form");
const _contracts_1 = require("../_contracts");
/**
 * Component that contains a complete questionnaire needed to **EDIT** the `Heading`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
let HeadingModuleForm = HeadingModuleForm_1 = class HeadingModuleForm extends form_1.AbstractModuleForm {
    constructor() {
        super(...arguments);
        /**
         * @inheritDoc
         * @override
         */
        this.initialContent = HeadingModuleForm_1.getInitialContent();
    }
    /**
     * TODO: Description.
     */
    get headingOptions() {
        const options = [];
        for (let i = 1; i < 7; i++) {
            options.push({
                label: `${i}`,
                value: i
            });
        }
        return options;
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialConfig() {
        return {
            driver: _contracts_1.ModuleDriver.Heading,
            size: {
                colSpan: 6,
                rowSpan: 1,
                minColSpan: 2,
                minRowSpan: 1,
                isResizable: true
            }
        };
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialContent() {
        return {
            level: 1,
            text: ''
        };
    }
};
HeadingModuleForm = HeadingModuleForm_1 = __decorate([
    vue_property_decorator_1.Component({
        name: 'HeadingModuleForm',
        components: { DashmixInput: backoffice_1.DashmixInput, DashmixSelect: backoffice_1.DashmixSelect, FormErrors: form_2.FormErrors },
        template: `
    <div>
      <div class="form-group">
        <label for="level">{{ $t('forms.heading.level') }}</label>
        <DashmixSelect name="level" :model.sync="_content.level" :options="headingOptions" />
      </div>

      <div class="form-group">
        <label for="text">{{ $t('forms.heading.content') }}</label>
        <DashmixInput name="text" :model.sync="_content.text" />
      </div>

      <!-- Form errors -->
      <FormErrors v-if="errors" v-bind="{ errors }" class="mt-3" />
    </div>
  `
    })
], HeadingModuleForm);
exports.HeadingModuleForm = HeadingModuleForm;
//# sourceMappingURL=Heading.form.js.map